import { render, staticRenderFns } from "./ServicioFormModal.vue?vue&type=template&id=5178d9ba"
import script from "./ServicioFormModal.vue?vue&type=script&lang=js"
export * from "./ServicioFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports